import moment from "moment";
import localStorageService from "../services/LocalStorageService";
import Swal from "sweetalert2";

export function capitalizeFirstLetter(str = "") {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
}

export const formatDateTime = (date = "") => {
  return moment(date).local().format("hh:mm A YYYY-MM-DD");
};

export const getRequestType = (type) => {
  return type === "adjustment_for_transfer"
    ? "Adjustment For Transfer"
    : type === "adjustment_for_lost_items"
    ? "Adjustment For Lost"
    : type === "adjustment_for_damaged_items"
    ? "Adjustment For Damaged"
    : type === "adjustment_for_supplies_consumption"
    ? "Adjustment For Supplies Consumption"
    : type === "adjustment_for_excess_good_stock"
    ? "Adjustment For Excess Good Stock"
    : "Conversion";
};

export const trimText = (text = "", maxLength = 0) => {
  if (text.length <= maxLength) {
    return text;
  }

  const trimmedText = text.substring(0, maxLength).trim();
  return trimmedText + " ...";
};

export const blobUrlToDataUrl = (data) => {
  const blob = new Blob([data], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "Processed File.csv"; // The file name
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
export const setLabel = (item = {}) => {
  let data = "";

  if (item && item?.alu !== null) {
    data += item?.alu;
  }

  if (item && item.description1 !== null) {
    data += data.length > 0 ? " - " + item?.description1 : item?.description1;
  }

  if (item && item.description3 !== null) {
    data += data.length > 0 ? " - " + item?.description3 : item?.description3;
  }

  return data;
};

export const getValueByKeyIfExist = (array = [], key = "") => {
  for (const obj of array) {
    if (key in obj) {
      return { value: obj[key], isPresent: true };
    }
  }

  return { value: null, isPresent: false };
};

export const isTokenExpired = () => {
  const token = localStorageService.getItem("token");
  if (!token) {
    return true;
  }
  const decodedToken = JSON.parse(atob(token.split(".")[1]));
  const expirationTime = decodedToken.exp * 1000;
  return Date.now() >= expirationTime;
};

export const createEndpoint = (baseUrl, pathParams = [], queryParams = {}) => {
  const path = pathParams.filter(Boolean).join("/");
  const query = new URLSearchParams(queryParams).toString();
  let endURL = baseUrl;
  if (path) {
    endURL += `/${path}`;
  }
  if (query) {
    endURL += `?${query}`;
  }
  return endURL;
};

export const downloadCSV = (csvUrl, name) => {
  const link = document.createElement("a");
  link.setAttribute("href", csvUrl);
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
};

export const showMessage = (icon, title) => {
  Swal.fire({
    position: "center",
    icon: icon,
    title: title,
    showConfirmButton: false,
    timer: 1500,
  });
};

export const debounce = (func, wait, immediate) => {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
